// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "./CompanySlider.css";

// Import your logos
import logo1 from "./img/placement-logo-2020-1.png";
import logo2 from "./img/66.png";
import logo3 from "./img/placement-logo-2020-12.png";
import logo4 from "./img/placement-logo-2020-13.png";
import logo5 from "./img/placement-logo-2020-14.png";
import logo6 from "./img/placement-logo-2020-15.png";
import logo7 from "./img/placement-logo-2020-16.png";
import logo8 from "./img/placement-logo-2020-14sdf.png";

export default function CompanySlider() {
  const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8];
  return (
    <div className="placement-slider">
      <h2 className="slider-title">Our Placement Partners</h2>
      <div className="slider-container">
        <div className="slider-track">
          {logos.concat(logos).map((logo, index) => (
            <div className="logo-card" key={index}>
              <img src={logo} alt={`company-logo-${index}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
